import { IconProps } from "./type";

const DepositIcon = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5713 29.7148H6.857"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <path
        d="M24.2419 7.11181L7.27137 24.0824M6.46325 11.9605V24.8905H19.3932"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DepositIcon;
